/**
 * Product mockup used in the hero and the pricing card.
 * While empty, a code-drawn cover in the product identity is shown.
 */
export const PRODUCT_MOCKUP =
  'https://cdn.magicpatterns.com/uploads/u8Pm6mPwyrMy8yEJychRMu/Photorealistic-product-mockup-3-2-horiz.png'

export const PRODUCT_MOCKUP_ALT =
  'The six volumes of 52 Weeks of Speaking — Finding the Voice, Thinking on Your Feet, Building the Talk, Owning the Room, Moving People and Showtime — standing on a desk in a speaking class'

export const PRODUCT_NAME = '52 Weeks of Speaking'

/** Where the pricing button sends the buyer. */
export const CHECKOUT_URL = 'https://52-weeks-of-speaking.impultienda.ar/checkout'
